// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__ndgyI","Label":"Checkbox_Label___3P3e","InputElement":"Checkbox_InputElement__3QFVz","Invalid":"Checkbox_Invalid__2P1EV"};